import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  CheckSufficientCreditsApplicationErrors,
  CheckSufficientCreditsResponse,
  GetCreditDataResponse,
  checkSufficientCredits as universalCheckSufficientCredits,
  getCreditData as universalGetCreditData,
} from './multilingual-machine-v1-credit-data-translation-credits.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/multilingual' };

export function getCreditData(httpClient: HttpClient): GetCreditDataSignature {
  return () =>
    universalGetCreditData(
      // @ts-ignore
      { httpClient }
    );
}

interface GetCreditDataSignature {
  /**
   * Retrieves a site's word credit data.
   *
   * For sites with a limited quota, you can calculate the available word credits by subtracting the credits used from the quota.
   * For example, if a site has a quota of 100 credits and all credits have been used (`"creditsUsed": 100`), the available word credits will be 0.
   * If a Wix user purchases an additional 50 credits, the `quota` will increase to `150`, and the site will have 50 available word credits.
   */
  (): Promise<
    NonNullablePaths<GetCreditDataResponse, `creditData.quotaType`, 3>
  >;
}

export function checkSufficientCredits(
  httpClient: HttpClient
): CheckSufficientCreditsSignature {
  return (wordCount: number) =>
    universalCheckSufficientCredits(
      wordCount,
      // @ts-ignore
      { httpClient }
    );
}

interface CheckSufficientCreditsSignature {
  /**
   * Checks whether a site has enough credits to translate the specified number of words.
   * @param - Number of words to translate.
   */
  (wordCount: number): Promise<
    NonNullablePaths<CheckSufficientCreditsResponse, `sufficientCredits`, 2> & {
      __applicationErrorsType?: CheckSufficientCreditsApplicationErrors;
    }
  >;
}

export {
  Asset,
  CheckSufficientCreditsRequest,
  CheckSufficientCreditsResponse,
  CreditData,
  CreditDataTypeOneOf,
  DeleteContext,
  DeleteStatus,
  EditorlessAssigned,
  EditorlessUnassigned,
  Empty,
  GetCreditDataRequest,
  GetCreditDataResponse,
  LimitedQuota,
  MetaSiteSpecialEvent,
  MetaSiteSpecialEventPayloadOneOf,
  Namespace,
  NamespaceChanged,
  OdeditorAssigned,
  OdeditorUnassigned,
  PicassoAssigned,
  PicassoUnassigned,
  Quota,
  ReportCreditUsageRequest,
  ReportCreditUsageResponse,
  ServiceProvisioned,
  ServiceRemoved,
  SiteCreated,
  SiteCreatedContext,
  SiteDeleted,
  SiteHardDeleted,
  SiteMarkedAsTemplate,
  SiteMarkedAsWixSite,
  SitePublished,
  SitePurgedExternally,
  SiteRenamed,
  SiteTransferred,
  SiteUndeleted,
  SiteUnpublished,
  SiteUrlChanged,
  State,
  StudioAssigned,
  StudioTwoAssigned,
  StudioTwoUnassigned,
  StudioUnassigned,
  UpdateCreditRequest,
  UpdateCreditResponse,
  UserDomainMediaDisabled,
  UserDomainMediaEnabled,
  WixelAssigned,
  WixelUnassigned,
} from './multilingual-machine-v1-credit-data-translation-credits.universal.js';
